// extracted by mini-css-extract-plugin
module.exports = {"desktop":"BodyTopMain_desktop_2lFTK","mobile":"BodyTopMain_mobile_70MGG"};